<template>
  <div class="additional-guests-form form-container">
    <h3>Additional Guests</h3>
    <div class="field-set field-triple">
      <div class="field-group">
        <label>Adults</label>
        <NumberInput
          name="occupants"
          v-model="occupants"
          :value="occupants"
          placeholder="Number of Adults"
          :max="$store.state.app_data.max_guests" />
      </div>
      <div class="field-group">
        <label>Children</label>
        <NumberInput name="occupants_small" v-model="occupants_small" :value="occupants_small" placeholder="Number of Children"/>
      </div>
      <div class="field-group">
        <label>Infants</label>
        <NumberInput name="infants" v-model="infants" :value="infants" placeholder="Number of Infants"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import NumberInput from './NumberInput.vue';

export default {
  components: {
    NumberInput
  },
  computed: {
    ...mapFields([
      'form.occupants',
      'form.occupants_small',
      'form.infants',
    ]),
  }
}
</script>
